import { Button, Tabs, message, Row, Checkbox, Input } from "antd";
import { useState, useRef, useEffect } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import "./salaryOfferModeller.less";
import { panels } from "./config";
import {
  ErrorServices,
  useCreateOfferModellerMutation,
  useFetchAutoPopulateDataQuery,
  useUpdateOfferStatusMutation,
  useSendEmailMutation,
  // useReviseOfferMutation,
} from "@services";
import { useTypedSelector } from "@hooks";
import { paths, permissions } from "@router";
import { handleStage, offerModellerInitialState } from "@store/offers";
import CustomButton from "@/components/customButton";
import { roles } from "@/constants";
import { isDraft } from "@reduxjs/toolkit";
import { checkPermission } from "@/utils";
import customErrorMessage from "@/components/CustomErrorMessage";
import Modal from "@components/Modal";

const { TabPane } = Tabs;

const SalaryOfferModeller = () => {
  const { role } = useTypedSelector(state => state.auth?.user!);
  const { offer_annual, show_current } = useTypedSelector(
    state => state?.offers
  );
  const typeKey = offer_annual ? "annual" : "monthly";
  const showCurrentKey = show_current ? "true" : "false";

  const [isEmailSent, setIsEmailSent] = useState(false);
  const [activeKey, setActiveKey] = useState<string>("1");
  const [refreshTrigger, setRefreshTrigger] = useState<number>(0);
  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");

  const dispatch = useDispatch();
  const [isEmail, setIsEmail] = useState(false);
  const { search } = useLocation();
  const isRevised = search === "?mode=revise";
  const draft = useRef<boolean>(false);
  const accept = useRef<boolean>(false);
  const { offer } = useTypedSelector(state => state?.offers);
  const { company } = useTypedSelector(state => state.auth?.user!);
  const { id: company_id } = company!;
  const history = useHistory();
  const { offerModeller } = useTypedSelector(state => state.offers);
  const [createOfferModeller, { isLoading: isCreating }] =
    useCreateOfferModellerMutation();
  const [sendEmail, { isLoading: isSending }] = useSendEmailMutation();
  const [downloadPdf, setDownloadPdf] = useState(false);
  const [savedStep, setSavedStep] = useState({ state: false });
  const [updateOfferStatus, { isLoading: isUpdating }] =
    useUpdateOfferStatusMutation();
  const location = useLocation();
  const { candidateDetails, positionDetails } = useTypedSelector(
    state => state.offers
  );
  const queryString = location.hash.split("?")[1] || "";
  // // // khurram
  // //  const [reviseOffer, { isLoading, isError, isSuccess, error }] = useReviseOfferMutation();
  useFetchAutoPopulateDataQuery(
    {
      company_id,
      offer_id: offer?.id,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: !offer?.id,
    }
  );

  const handleChange = (key: string) => {
    setActiveKey(key);
  };

  const handleSubmit = async (is_draft: boolean, previewEmail = false) => {
    try {
      draft.current = is_draft;
      // ===== LTI payload normalization (units -> amount) =====
      const stockValue =
        Number(offerModeller?.offer_lti?.selected_stock_value) || 1;

      // 1) Replace value for unit===false (units) with amount = units * stockValue
      const normalizedOtherLtis = (
        offerModeller?.offer_lti?.other_ltis || []
      ).map((lti: any) => {
        if ((!lti.is_current && lti.value) || lti?.equity_mid) {
          return {
            ...lti,
            equity_mid: lti?.equity_mid,
            value: lti?.is_amount
              ? lti?.equity_mid
              : lti?.equity_mid || (lti?.equity_mid == 0 && !lti?.unit)
              ? Math.round(lti?.equity_mid * stockValue)
              : Math.round(lti?.value), // send amount instead of units
          };
        }
        return lti;
      });

      // 2) Recompute proposed_total_lti to match UI's getLtiTotal
      let adjustedProposedLTI =
        offerModeller?.offer_lti?.proposed_total_lti || 0;
      (offerModeller?.offer_lti?.other_ltis || [])
        .filter((x: any) => !x.is_current)
        .forEach((x: any) => {
          if (x.value) {
            // adjustedProposedLTI =
            //   adjustedProposedLTI - x.value + Math.round(x.value * stockValue);
          }
        });

      // 3) Build payload with normalized other_ltis and adjusted totals
      const payload = {
        ...offerModeller,
        offer_lti: {
          ...offerModeller.offer_lti,
          other_ltis: normalizedOtherLtis,
          proposed_total_lti: Math.round(adjustedProposedLTI),
          // keep currency total in sync if needed
          proposed_currency_total: offerModeller?.currencyRate
            ? Math.round(
                Math.round(adjustedProposedLTI) * offerModeller.currencyRate
              )
            : offerModeller?.offer_lti?.proposed_currency_total,
        },
      };
      // ===== end LTI payload normalization =====

      // if(isRevised){

      //   await reviseOffer({
      //     company_id,
      //     id: offer?.id,
      //     body: { ...payload, is_draft },

      //   }).unwrap();
      //   message.success(`Offer ${is_draft ? "saved" : "placed"} successfully`);

      // }else{

      //   await createOfferModeller({
      //     company_id,
      //     id: offer?.id,
      //     // body: { ...offerModeller, is_draft },
      //     body: { ...payload, is_draft },

      //   }).unwrap();
      //   message.success(`Offer ${is_draft ? "saved" : "placed"} successfully`);
      // }

      await createOfferModeller({
        company_id,
        id: offer?.id,
        // body: { ...offerModeller, is_draft },
        body: { ...payload, is_draft },
      })
        .unwrap()
        .then(() => {
          if (!isEmail) {
          } else {
            if (!is_draft) {
              setIsEmailSent(true);
              setRefreshTrigger(prev => prev + 1);
            }
          }

          message.success(
            `Offer ${is_draft ? "saved" : "placed"} successfully`
          );
        });
      if (is_draft) {
        setActiveKey("7");
      }

      if (previewEmail === false && !is_draft) {
        if (!isEmail && !savedStep.state) {
          await sendEmail({
            company_id,
            id: offer?.id,
            type: typeKey,
            show_current: showCurrentKey,
          })
            .unwrap()
            .then(() => {
              message.success(`Offer Email is sent successfully`);
              setIsEmailSent(true);
            });
          setRefreshTrigger(prev => prev + 1); // force re-render on each tab activation
        }
      }

      if (downloadPdf && !is_draft) {
        handleDownload();
      }

      // if (!is_draft) {
      //   history.push(paths.client.offers.active);

      // }
    } catch (err) {
      // ErrorServices(err);
    }
  };

  const update = async (is_accepted: boolean) => {
    try {
      accept.current = is_accepted;
      await updateOfferStatus({
        company_id,
        id: offer?.id,
        status: is_accepted ? "ACCEPTED" : "REJECTED",
      }).unwrap();
      message.success(`Offer ${is_accepted ? "Accepted" : "Rejected"}!`);
      history.push(paths.client.offers.active);
    } catch (err) {
      ErrorServices(err);
    }
  };

  const handleRejectConfirm = async () => {
    try {
      await updateOfferStatus({
        company_id,
        id: offer?.id,
        status: "REJECTED",
        body: rejectionReason ? { rejection_reason: rejectionReason } : {},
      }).unwrap();

      message.success("Offer Rejected!");
      history.push(paths.client.offers.active);
    } catch (err) {
      ErrorServices(err);
    } finally {
      setRejectModalVisible(false);
      setRejectionReason("");
    }
  };

  useEffect(() => {
    if (isEmailSent) {
      history.push(paths.client.offers.active);
    }
  }, [isEmailSent]);

  async function handleDownload() {
    try {
      const tokenString = localStorage.getItem("tokens");

      if (!tokenString) {
        customErrorMessage("No token found. Please log in again.");
        return;
      }

      let tokens;
      try {
        tokens = JSON.parse(tokenString);
      } catch (err) {
        customErrorMessage("Invalid token format.");
        return;
      }

      if (!tokens.access) {
        customErrorMessage("Access token missing.");
        return;
      }

      const today = new Date().toISOString().split("T")[0];

      const url = `${process.env.REACT_APP_BASE_URL}/company/${company_id}/offer/${offer?.id}/email-page/pdf/`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokens?.access}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to download PDF (Status: ${response.status})`);
      }
      message.success(
        "The PDF is being generated and will be downloaded shortly."
      );
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;

      link.download = `${
        offer?.original_offer_id ? offer?.original_offer_id : offer?.id
      }_${candidateDetails?.candidate_name}_${
        positionDetails?.job_title
      }_${today}.pdf`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      customErrorMessage(
        error?.message || "Something went wrong while downloading."
      );
    }
  }

  useEffect(() => {
    const queryString = location?.pathname?.includes("?")
      ? location?.pathname?.split("?")[1]
      : location?.search?.slice(1);

    if (!queryString) return;

    const params = new URLSearchParams(queryString);

    const paramNames = Array?.from(params.keys());
    if (paramNames?.length > 0) {
      const name = paramNames?.[0]; // "step"
      const value = params?.get(name); // "1"
      if (name == "step") {
        setSavedStep({ state: value == "1" || value == "2" });
      }
    }
  }, [location?.pathname, location?.search]);

  return (
    <>
      <div
        style={{
          backgroundColor: "#F9FAFD",
          border: "1px solid #DDE5EF",
        }}
      >
        <Tabs
          tabBarStyle={{
            backgroundColor: "#F9FAFD",
            padding: "13px",
            borderWidth: "1px",
            borderColor: "#DDE5EF",
          }}
          activeKey={activeKey}
          onChange={handleChange}
        >
          {panels?.map(
            ({
              id,
              header,
              component: Component,
            }: {
              id: string;
              header: string;
              component: any;
            }) => (
              <TabPane
                style={{
                  marginTop: "-15px",
                }}
                tab={header}
                key={id}
              >
                {id === "7" ? (
                  <Component
                    isEmailSent={isEmailSent}
                    offerId={offer?.id}
                    companyId={company_id}
                    refreshTrigger={refreshTrigger}
                    activeKey={activeKey}
                    handleSubmit={() => handleSubmit(true, true)}
                  />
                ) : (
                  <Component />
                )}
              </TabPane>
            )
          )}
        </Tabs>
        <div className="transparent height-40" />
        <Row className="offers__form__fields__btns salary-offer__btns transparent"></Row>
      </div>
      {!savedStep?.state && checkPermission(permissions.CREATE_OFFER) && (
        <div className="block mt-2 mb-2">
          <Checkbox
            checked={downloadPdf}
            onChange={e => setDownloadPdf(e.target.checked)}
            className="mt-1 mb-1"
          >
            Download PDF version of offer (record/regulatory)
          </Checkbox>
          <br />
          <Checkbox
            checked={isEmail}
            onChange={e => setIsEmail(e.target.checked)}
            className="mt-1 mb-1"
          >
            Do not send offer email to Candidate
          </Checkbox>
        </div>
      )}
      {window.location.pathname?.includes("/create") ||
      offer?.status === "DRAFTED" ||
      isRevised ? (
        <div className="flex items-center   justify-around p-6 border-t border-solid border-blueGray-200 rounded-b">
          {checkPermission(permissions.UPDATE_OFFER) && (
            <CustomButton
              customClasses={`!px-10  py-3 w-3/12 font-semibold 
            "bg-themeButtonGray text-white  cursor-not-allowed"
          `}
              onClick={() => handleSubmit(false)}
              btnName=""
            >
              {isSending && <LoadingOutlined className="spinner" />}
              {isCreating && isSending && !draft?.current ? (
                <LoadingOutlined className="spinner" />
              ) : (
                "Place Offer"
              )}
            </CustomButton>
          )}
          {!isRevised && checkPermission(permissions.UPDATE_OFFER) && (
            <CustomButton
              customClasses={`!px-10  py-3 w-3/12 font-semibold 
              "bg-themeButtonGray text-white  cursor-not-allowed"
            `}
              onClick={() => handleSubmit(true)}
              btnName=""
            >
              {isCreating && !isSending ? (
                <LoadingOutlined className="spinner" />
              ) : (
                "Save as draft"
              )}
            </CustomButton>
          )}

          {!isRevised && (
            <CustomButton
              onClick={() => dispatch(handleStage("CANDIDATE_DETAILS"))}
              btnName=""
              customClasses={`!px-10 py-3  w-3/12 
              "bg-themeButtonGray  text-themeBlack"
            font-semibold`}
            >
              Cancel
            </CustomButton>
          )}
        </div>
      ) : (
        <>
          {offer?.status === "PLACED" ? (
            <div className="flex items-center   justify-around p-6 border-t border-solid border-blueGray-200 rounded-b">
              {/* role access to restrict accept and reject for tom sales */}
              {role &&
                !roles.onlyCompanyAdminAndSales.includes(role) &&
                checkPermission(permissions.UPDATE_OFFER) && (
                  <>
                    {" "}
                    <CustomButton
                      customClasses={`!px-10  py-3 w-3/12 font-semibold 
                "bg-themeButtonGray text-white  cursor-not-allowed"
              `}
                      btnName=""
                      onClick={() => update(true)}
                    >
                      {isUpdating && accept?.current ? (
                        <LoadingOutlined className="spinner" />
                      ) : (
                        "Accept"
                      )}
                    </CustomButton>
                    <CustomButton
                      customClasses={`!px-10  py-3 w-3/12 font-semibold 
                "bg-themeButtonGray text-white  cursor-not-allowed"
              `}
                      onClick={() => {
                        accept.current = false;
                        setRejectModalVisible(true);
                      }}
                      btnName=""
                    >
                      {isUpdating && !accept?.current ? (
                        <LoadingOutlined className="spinner" />
                      ) : (
                        "Reject"
                      )}
                    </CustomButton>
                  </>
                )}
              <CustomButton
                customClasses={`!px-10 py-3  w-3/12 
                "bg-themeButtonGray  text-themeBlack"
              font-semibold`}
                onClick={() => history.goBack()}
                btnName=""
              >
                Cancel
              </CustomButton>
            </div>
          ) : (
            <CustomButton
              customClasses={`!px-10 py-3  w-3/12 
          "bg-themeButtonGray  text-themeBlack"
        font-semibold`}
              onClick={() => history.goBack()}
              btnName=""
            >
              Cancel
            </CustomButton>
          )}
        </>
      )}

      <Modal
        className="w-1/3"
        title="Reject Offer"
        isVisible={rejectModalVisible}
        setIsVisible={setRejectModalVisible}
        width={500}
        footer={[
          <div key="cancel" style={{ marginRight: 8 }}>
            <CustomButton
              btnName="Cancel"
              onClick={() => setRejectModalVisible(false)}
            />
          </div>,
          <div key="reject">
            <CustomButton
              btnName="Reject"
              isLoading={isUpdating}
              onClick={handleRejectConfirm}
            />
          </div>,
        ]}
      >
        <Input.TextArea
          rows={5}
          placeholder="Enter rejection reason (optional)"
          value={rejectionReason}
          onChange={e => setRejectionReason(e.target.value)}
        />
      </Modal>
    </>
  );
};

export default SalaryOfferModeller;
